import { asyncPayrollAction } from "../../../../../redux/actions/Payroll/Thunk/payroll.thunk";
import MultiRoute from "../../../../common/MultiRoute/MultiRoute";
import Header from "../../../../layout/Header/Header";
import Footer from "../../../../layout/Footer/Footer";
import { ChangeMonths } from "../../../../common/componentsTerminal/ChangeMonths/ChangeMonths";
import { ScrollButton } from "../../../../common/componentsTerminal/ScrollButton/ScrollButton";
import { isTerminal } from "../../../../../constants";

import { useDispatch, useSelector } from "react-redux";
import { useEffect, useRef } from "react";
import { ClipLoader } from "react-spinners";
import moment from "moment";
import {useState} from "react";

isTerminal ? import("./PayrollTerminal.scss") : import("./PayrollStyle.scss");

// const currentDate = moment();
const maxDate = moment();

export const PayrollPage = () => {
    const dispatch = useDispatch();
    const { payroll, isLoading, error } = useSelector(state => state.payroll);
    const iframeRef = useRef(null);
    console.log("currentDate: ", currentDate)
    const [currentDate, setCurrentDate] = useState(moment());


    const onChange = (date) => {
        // console.log(currentDate.format("YYYY"))
        dispatch(asyncPayrollAction({months:Number(currentDate.format("MM")) , year: Number(currentDate.format("YYYY"))} ));
    };

    useEffect(() => {
        // onChange(currentDate);
        dispatch(asyncPayrollAction({months:Number(currentDate.format("MM")) , year: Number(currentDate.format("YYYY"))} ));

    }, []);

    return (
        <>
            <Header />
            <div className="buttons-month__wrapper">
                <MultiRoute
                    subHeader="Расчетный лист"
                    breadCrumbs
                    styleParent={"reward__header"}
                />
                <ChangeMonths
                    setCurrentDate={setCurrentDate}
                    currentDate={currentDate}
                    // date={currentDate}
                    maxDate={maxDate}
                    onChange={onChange}
                    disabled={isLoading}
                />
            </div>
            <div className="payroll__wrapper">
                {isLoading && <div className="loader__container"><ClipLoader size={72}/></div>}
                {payroll && !isLoading && !error && <div className="reward">
                    <iframe title="HTML Viewer"
                        className="reward__iframe" srcDoc={payroll.data} ref={iframeRef} />

                    {isTerminal && <ScrollButton propsClassName=".reward__iframe" isIframe iframeRef={iframeRef} />}
                </div>}

                {!isLoading && !payroll && !error && <div  className="payroll__default">Расчетный лист отсутствует</div>}
                {error && !isLoading && <div className="payroll__default">Что-то пошло не так обратитесь в службу поддержки</div>}
            </div>
            <Footer />
        </>
    );
};
